'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'lightbulb-on';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f672';
var svgPathData = 'M459.3 324.1c-16.5 17.4-31.2 37.6-38.4 59.9l-201.7 0c-7.3-22.3-21.9-42.5-38.4-59.9-32.7-34.4-52.7-80.9-52.7-132.1 0-106 86-192 192-192S512 86 512 192c0 51.2-20 97.7-52.7 132.1zM224 448l0-16 192 0 0 16c0 44.2-35.8 80-80 80l-32 0c-44.2 0-80-35.8-80-80zm16-264c0-39.8 32.2-72 72-72 13.3 0 24-10.7 24-24s-10.7-24-24-24c-66.3 0-120 53.7-120 120 0 13.3 10.7 24 24 24s24-10.7 24-24zM58.7 26.5l32 16c11.9 5.9 16.7 20.3 10.7 32.2S81.1 91.4 69.3 85.5l-32-16C25.4 63.5 20.6 49.1 26.5 37.3S46.9 20.6 58.7 26.5zm544 42.9l-32 16c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l32-16c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2zM24 168l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm560 0l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM90.7 341.5l-32 16c-11.9 5.9-26.3 1.1-32.2-10.7s-1.1-26.3 10.7-32.2l32-16c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2zm480-42.9l32 16c11.9 5.9 16.7 20.3 10.7 32.2s-20.3 16.7-32.2 10.7l-32-16c-11.9-5.9-16.7-20.3-10.7-32.2s20.3-16.7 32.2-10.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLightbulbOn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;